(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inplace-video-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var popupTriggers = document.querySelectorAll('.video-image.vimeo_video_include');
  popupTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() { 
      var popupId = trigger.getAttribute('data-popup');
      const main_video_wrapper = document.querySelector('#'+popupId);
      if(main_video_wrapper.classList.contains('vimeo_video')){
        
      }else{
        document.querySelector('#'+popupId).classList.add("vimeo_video");
        const iframe_src = main_video_wrapper.querySelector('iframe').getAttribute('src'); 
        main_video_wrapper.querySelector('iframe').setAttribute('src', iframe_src.concat('?autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1'));       
      }  
    });  
  });  
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var popupTriggers = document.querySelectorAll('.video-image');
    popupTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var popupId = trigger.getAttribute('data-popup');
        const main_popup_wrapper = document.querySelectorAll('.popup-wrapper');
        main_popup_wrapper.forEach(popup=>{
          if(popup.getAttribute('id') == popupId){
            const _iframe_src = popup.querySelector('iframe').getAttribute('src');     
            popup.querySelector('iframe').setAttribute('src', _iframe_src.concat('&amp;autoplay=1&mute=0'));
          }
        });
        document.querySelector(`.popup-wrapper#${popupId}`).style.display = 'block';
      });
    });
  var popupCloseButtons = document.querySelectorAll('.popup-close');
    popupCloseButtons.forEach(function(closeButton) {
      closeButton.addEventListener('click', function(event) {
        const main_popup_wrapper = closeButton.closest('.popup-wrapper');
        const _iframe_src = main_popup_wrapper.querySelector('iframe').getAttribute('src');
        const _updated_iframe_src = _iframe_src.replace('&amp;autoplay=1&mute=0', '');
        main_popup_wrapper.querySelector('iframe').setAttribute('src', _updated_iframe_src);
        main_popup_wrapper.style.display = 'none';
      });
    });
});


  } catch(e) { console.error(e); }
})();
})();
